module.exports = __webpack_public_path__ + "static/image2-0be23d7e776d1da2b48c8763f236147d.png";